import SlsCidadeClient from '@/api/Cadastros/Gerais/sls-cidade.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSCidadeService {
  constructor() {
    this.client = new SlsCidadeClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os cidade');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Cidade');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Cidade');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Cidade');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Cidade');
    }
  }
}
